import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tag-inserter"
export default class extends Controller {
  static targets = ["button", "dropdown"]

  connect() {
    this.isOpen = false
    // Добавляем обработчик для закрытия при клике вне элемента
    document.addEventListener("click", this.outsideClickHandler)
  }

  toggle() {
    this.isOpen = !this.isOpen
    
    if (this.isOpen) {
      this.dropdownTarget.classList.add("show")
      this.buttonTarget.classList.add("open")
    } else {
      this.dropdownTarget.classList.remove("show")
      this.buttonTarget.classList.remove("open")
    }
  }

  insertTag(event) {
    event.preventDefault()
    const tag = event.currentTarget.dataset.tag
    
    // Ищем ближайшее поле textarea в родительском элементе
    const formGroup = this.element.closest('.form-group')
    const textarea = formGroup ? formGroup.querySelector('textarea') : null
    
    if (!textarea) {
      console.error('Textarea не найдена')
      return
    }
    
    // Получаем позицию курсора
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const text = textarea.value
    
    // Вставляем тег на место курсора
    const newText = text.substring(0, start) + tag + text.substring(end)
    textarea.value = newText
    
    // Устанавливаем курсор после вставленного тега
    const newPosition = start + tag.length
    textarea.setSelectionRange(newPosition, newPosition)
    textarea.focus()
    
    // Закрываем выпадающий список
    this.close()
  }

  close() {
    this.isOpen = false
    this.dropdownTarget.classList.remove("show")
    this.buttonTarget.classList.remove("open")
  }

  // Закрываем выпадающий список при клике вне его
  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

  outsideClickHandler = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
